import styled from 'styled-components';

import { fontWeights } from 'ui/theme';
import { UnarchivableItemDisplayText, UnarchivableItem } from '../types';

const BoldText = styled.b`
  font-weight: ${fontWeights.bold};
`;

type SingularUnarchivePromptProps = {
  displayTextForContentItems: UnarchivableItemDisplayText;
  content: UnarchivableItem[];
};

export const SingularUnarchivePrompt = ({
  content,
  displayTextForContentItems,
}: SingularUnarchivePromptProps) => (
  <p>
    Are you sure that you want to unarchive the {displayTextForContentItems.itemTypeName.singular}{' '}
    <BoldText>{content[0].name}</BoldText>?
  </p>
);
